import {graphqlQuery} from '../utils/graphqlQuery';

export const OPERATION_NAME = 'graphql_get_travelerSentimentHighlights';

export const sentimentHighlightsQuery = `
    query travelerSentiments($crisisType: CrisisType!, $listingId: String!) {
        travelerSentiments(crisisType: $crisisType, listingId: $listingId) {
            header
            badgeDescription
            viewAll
            sentiments {
                reservationUuid
                verifiedBooking
                submittedDate
                travelerFeedback
                travelerName
                ratingValue
            }
            disclaimer
            moreText
            lessText
        }
    }`;

export async function getSentimentHighlightsGraphQl({crisisType, listingId, locale}) {
    return graphqlQuery(OPERATION_NAME, sentimentHighlightsQuery, {crisisType, listingId}, locale);
}

export default getSentimentHighlightsGraphQl;
